module.exports = __webpack_public_path__ + "img/Group 1505.2fc0912c.svg";